  // Ensure this runs after the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {

    // --- Cart Drawer Visibility Tracker & Shopify Event Publisher ---

    const cartDrawerSelector = '.cart-drawer'; // Define selector
    const activeClass = 'is-active';          // Define active class
    const customEventName = 'cart_drawer_opened'; // Define your custom event name
    const subtotalSelector = '.cart-drawer__subtotal span:last-child'; // Specific selector for the subtotal value SPAN

    // 1. Find the target cart drawer element
    const cartDrawerElement = document.querySelector(cartDrawerSelector);

    // 2. Check if the element actually exists on the page
    if (!cartDrawerElement) {
      // console.warn(`Shopify Event Publisher: Element "${cartDrawerSelector}" not found on this page.`);
      return;
    }

    // 3. Track the current state
    let isCartDrawerCurrentlyVisible = cartDrawerElement.classList.contains(activeClass);

    // 4. Define the callback function
    const observerCallback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const targetElement = mutation.target;
          const isNowVisible = targetElement.classList.contains(activeClass);

          // 5. Check if the drawer just BECAME visible
          if (isNowVisible && !isCartDrawerCurrentlyVisible) {

            // --- Replace dataLayer.push with Shopify.analytics.publish ---

            console.log(`Cart drawer opened. Publishing Shopify custom event: ${customEventName}`); // Debugging

            // // 6a. Define the data payload (optional, can be empty object)
            // const event_data = {
            //   // You can add relevant data here if needed
            //   // e.g., timestamp: new Date().toISOString(),
            //   // e.g., source: 'cart-drawer-observer'
            // };

            let event_data = {};
            let numericSubtotal = null; // To store the cleaned number
  
            try {
              // 6a. Find the subtotal element using the specific selector
              //     We search within the cartDrawerElement to be slightly more specific,
              //     though document.querySelector would likely work too.
              const subtotalElement = cartDrawerElement.querySelector(subtotalSelector);
  
              if (subtotalElement) {
                const subtotalText = subtotalElement.textContent.trim(); // Get text like "$390.00"
  
                // 6b. Clean the text to get only the number
                //     Remove currency symbols ($), commas (,), and any other non-numeric characters except the decimal point.
                const cleanedSubtotalText = subtotalText.replace(/[^0-9.]/g, '');
                numericSubtotal = parseFloat(cleanedSubtotalText); // Convert to a number
  
                if (isNaN(numericSubtotal)) {
                    console.warn(`Could not parse subtotal value "${subtotalText}" to a number.`);
                    numericSubtotal = null; // Set back to null if parsing failed
                } else {
                    console.log('Subtotal extracted from DOM:', numericSubtotal); // Debugging
                }
  
              } else {
                console.warn(`Subtotal element "${subtotalSelector}" not found within the cart drawer.`);
              }
  
              // 6c. Define the data payload with the numeric subtotal
              event_data = {
                totalAmount: {
                  amount: numericSubtotal, // Use the numeric value (will be null if not found/parsed) 
                  currencyCode: "CAD",
                }
              };
  
            } catch (error) {
              console.error('Error reading subtotal from DOM:', error);
              // Optional: Populate event_data with error info
              event_data = {
                totalAmount: {
                  amount: 0, 
                  currencyCode: "CAD",
                }
              };
            }

            // 6b. Check if Shopify analytics context is available and publish the custom event
            if (typeof Shopify !== 'undefined' && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
              Shopify.analytics.publish(customEventName, event_data);
            } else {
              console.warn('Shopify.analytics.publish is not available. Cannot publish custom event.');
            }

            // --- End Replacement ---
          }
          // 7. Update the state tracker
          isCartDrawerCurrentlyVisible = isNowVisible;
        }
      }
    };

    // 8. Create the observer
    const observer = new MutationObserver(observerCallback);

    // 9. Configure the observer
    const config = { attributes: true, attributeFilter: ['class'] };

    // 10. Start observing
    observer.observe(cartDrawerElement, config);
    // console.log(`Shopify Event Publisher: Observing element "${cartDrawerSelector}" for class "${activeClass}".`); // Confirm observer is active

    // --- End Cart Drawer Visibility Tracker ---
  });